// Step 4 — Create your repos.
//
// One button. BKA calls the GitHub API to create both repos in the
// creator's account. Idempotent on resume: a repo that already exists
// is accepted rather than erroring (see onboardingStore.provisionRepos).

import { useAuthStore } from "../../store/authStore";
import { useOnboardingStore } from "../../store/onboardingStore";
import { privateRepoName, publicRepoName } from "../../lib/handle";

export function StepProvision() {
  const user = useAuthStore((s) => s.user)!;
  const handle = useOnboardingStore((s) => s.record?.handle) ?? "";
  const login = useOnboardingStore((s) => s.githubIdentity?.login) ?? "you";
  const busy = useOnboardingStore((s) => s.busy);
  const error = useOnboardingStore((s) => s.error);
  const provisionRepos = useOnboardingStore((s) => s.provisionRepos);

  return (
    <div className="step">
      <div className="step-kicker">Step 4 of 7</div>
      <h1 className="step-title">Create your two repos</h1>
      <p className="step-why">
        BKA will create these in your GitHub account now. Your <em>private</em> repo is where
        drafts and scratch live — nobody else sees it. Your <em>public</em> repo is where things
        go when you click Publish. Browse either on github.com any time; if you ever leave BKA,
        your content is right there.
      </p>

      <div className="prov-list">
        <div className="prov-item">
          <span className="prov-badge prov-private">private</span>
          <code>{login}/{privateRepoName(handle)}</code>
        </div>
        <div className="prov-item">
          <span className="prov-badge prov-public">public</span>
          <code>{login}/{publicRepoName(handle)}</code>
        </div>
      </div>

      <div className="step-actions">
        <button className="step-btn" disabled={busy} onClick={() => void provisionRepos(user.sub)}>
          {busy ? "Creating your repos…" : "Create my repos"}
        </button>
      </div>

      {error && (
        <div className="step-error">
          <div className="step-error-title">couldn't create repos</div>
          {error}
        </div>
      )}

      <style>{`
        .prov-list { display: flex; flex-direction: column; gap: var(--space-2); margin-bottom: var(--space-2); }
        .prov-item {
          display: flex; align-items: center; gap: var(--space-3);
          background: var(--paper-raised);
          border: 1px solid var(--line);
          border-radius: var(--radius-1);
          padding: var(--space-3) var(--space-4);
        }
        .prov-item code { font-family: var(--font-mono); font-size: 13px; color: var(--ink); }
        .prov-badge {
          font-family: var(--font-mono); font-size: 10px;
          text-transform: uppercase; letter-spacing: 0.06em;
          padding: 2px 8px; border-radius: 999px;
        }
        .prov-private { background: var(--paper-sunk); color: var(--ink-soft); }
        .prov-public { background: var(--teal-dim); color: var(--teal); }
      `}</style>
    </div>
  );
}
